import getClassNameReduxUtil from '@gymaholic/packages/src/modules/redux/utils/get-class-name/index.js'
import { logUtil } from 'packages/src'
import getIdReduxUtil from 'modules/redux/utils/get-id/index.js'
import { EXERCISE_CLASS_NAME } from '@gymaholic/packages'
import getPagePropertiesExerciseUtil from 'modules/exercise/redux/utils/get-page-properties/index.js'

const CLASS_NAME_TO_GETTER = {
  [EXERCISE_CLASS_NAME]: getPagePropertiesExerciseUtil
}

/**
 * @param props
 * @param props.instance
 * @param props.state
 * @param props.intl
 */
export default function getPagePropertiesFromInstanceReduxUtil (props) {
  const {
    instance,
    state,
    intl
  } = props

  const id = getIdReduxUtil(instance)
  const className = getClassNameReduxUtil(instance)

  const logPrefix = `id=${id} className=${className}`
  logUtil('getPagePropertiesFromInstanceReduxUtil').debug(`${logPrefix} [start]`)

  if (!className) {
    logUtil('getPagePropertiesFromInstanceReduxUtil').warn(`${logPrefix} [noop] no className`)
    return null
  }

  const getter = CLASS_NAME_TO_GETTER[className]
  if (!getter) {
    logUtil('getPagePropertiesFromInstanceReduxUtil').debug(`${logPrefix} [noop] no getter`)
    return {}
  }

  return getter({
    instance,
    state,
    intl
  })
}
